import { render } from "./OSCSettings.vue?vue&type=template&id=353dae88"
import script from "./OSCSettings.vue?vue&type=script&lang=js"
export * from "./OSCSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__